import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import type { FeatureTileName } from 'helpers/features';
import { mapFormData } from 'helpers/formData';

export interface PracticeSettingsFeatureTilesReorderPatchOptions {
  name: FeatureTileName;
  newIndex: number;
}

export function practiceSettingsFeatureTilesReorderApi(path: string) {
  return {
    path,
    PATCH: (values: PracticeSettingsFeatureTilesReorderPatchOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: mapFormData(values),
        },
      }),
  };
}
